// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f7e29f61","239":"a85729da","667":"e45560a8"}[chunkId] + ".chunk.js";
};